/**
 * Note that this should match the UUID namespaces used in the KG.
 */
export enum UuidNamespace {
  AccountToPersonalSpaceNamespace = "a5c8c855-37fe-4572-bbb8-66bd15fefdba",
  SyncModelNamespace = "DED407F4-2931-4A2F-875D-62B9196F9060",
}
